<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :field-name="projectId === 5? '사업장명' : ''"
    />

    <!-- 점검정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>담당부서</div>
          <div v-if="isPrint" class="print-input">{{ form.inputA_1 }}</div>
          <company-selector v-else v-model="form.inputA_0" :company-name="form.inputA_1" @select="targetCompany" :readonly="board.readonly" />
        </div>
        <div>
          <div>점검자명</div>
          <div v-if="isPrint" class="print-input">{{ form.inputA_2 }}</div>
          <ml-input v-else :readonly="board.readonly" placeholder="입력필드" v-model="form.inputA_2" />
        </div>
        <div>
          <div>점검일</div>
          <div v-if="isPrint" class="print-input">{{ form.inputA_3 }}</div>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputA_3" />
        </div>
      </div>
    </div>

    <!-- 업무 수행 여부 -->
    <div class="mt-28px">
      <div class="flex items-start mb-4">
        <h5><i class="dot"></i>하반기 업무 수행 여부</h5>
<!--        <div class="flex items-center cursor-pointer" @click="openPopup">-->
<!--          <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />-->
<!--          <span style="color: #7e72f2"> 이행사항 점검 시 작성요령 </span>-->
<!--        </div>-->
        <span class="ml-6">※ 점검표 입력 → PDF저장 → 공문시행 → 발송결재 공문 첨부</span>
      </div>

      <table-inspect-no
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        tableHeaderTitle="점검사항 및 세부내용"
        table-header-yes="이행"
        table-header-no="미이행"
        table-header-na="해당없음"
        table-header-note="비고(보완계획)"
        footer="※ (중처법=중대재해처벌 등에 관한 법률)"
        v-model="form.inspectList"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup id="popAlert" title="이행사항 점검 시 작성요령" :active.sync="showPopup">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>증빙자료 첨부</th>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">점검결과 판단기준(연번 1~8번)</b>
            <div>
              <p class="mb-1">1. 실시 : 점검항목을 100% 이행한 경우 (점검시점 기준)</p>
              <p class="mb-1">2. 미실시 : 점검항목을 이행 중이거나 이행하지 않은 경우</p>
              <p class="mb-1">3. 해당없음 : 점검항목과 무관한 경우</p>
            </div>
          </td>
        </tr>
        <tr>
          <td class="p-3 font-bold">반드시 디지털 안전보건 시스템(마엇)에 증빙자료 업로드 (업로드 매뉴얼 참고)</td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">작성요령</b>
            <ul>
              <li class="mb-1">연번 1 : <span style="color: #0029ff">시스템 ‘인력’</span> - 추가 인력 입력(관리부서, 수탁업체 인력 모두 입력 필수)</li>
              <li class="mb-1">연번 2 : <span style="color: #0029ff">시스템 ‘예산’ - 12월 페이지</span>에 예산 사용 금액 업로드 (2023년 계획 상 안전예산의 집행금액)</li>
              <li class="mb-1">
                연번 3 : <span style="color: #0029ff">② 시스템 ‘유해위험요인 관리(수시) - (사업장)유해위험요인 페이지</span><br />
                <span style="padding-left: 47px">원료, 제조물 사업장 유해위험요인 점검결과 및 기타 점검결과 자료(월별 점검표 등)</span>
              </li>
              <li class="mb-1">
                ①③④⑤ 제출한 안전관리계획에 포함되어 있을 경우 별도의 자료 제출 필요 없음. 점검표에는 ‘이행’에 체크 <br />
                <span style="color: #ff0000">※ 단, 안전계획를 제출하지 않았거나, 제출한 안전계획에 원료제조물 사업장에 대한 내용이 없을 경우 별도 제출하여야 함</span>
              </li>
              <li class="mb-1">
                연번 4 : 안전보건 관계 법령이란 <span style="color: #ff0000">사업장에 적용되는 모든 개별법령을 의미</span>함(보건위생법, 보육지원에 관한 법률 등)<br />
                <span style="padding-left: 47px; color: #0029ff">※ 사업장 담당자는 해당하는 개별법령을 확인하여 의무이행 여부를 자체적으로 점검하여야 함</span>
              </li>
              <li class="mb-1">
                연번 5 : <span style="color: #0029ff">① 시스템 ‘교육’</span> - 법정 의무교육<br />
                <span style="padding-left: 47px"> ② 미이수 사항 발견시 개선조치 계획 제출 </span>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectNo from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspectNo,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        inspectList: [
          {
            label: "필요한 안전인력 확보 [중처법 시행령 제8조제1호]",
            chlid: [
              {
                label: "사업장 안전보건 관리 업무 담당",
                is_checked: "",
              },
              {
                label: "유해위험요인 점검과 위험징후 발생시 대응 업무",
                is_checked: "",
              },
            ],
          },
          {
            label: "필요한 안전예산 편성·집행 [중처법 시행령 제8조제2호]",
            chlid: [
              {
                label: "인력,장비 등의 확보, 유지 등 안전보건 관련 인건비",
                is_checked: "",
              },
              {
                label: "유해위험요인 점검과 위험징후 발생시 대응 업무",
                is_checked: "",
              },
              {
                label: "그 밖의 원료·제조물 관련 안전보건에 관한 고시사항 관리 업무",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전보건 확보 조치 및 업무처리절차 마련 [중처법 시행령 제8조제3호]",
            chlid: [
              {
                label: "유해·위험요인의 주기적인 점검 및 절차 마련",
                is_checked: "",
              },
              {
                label: "유해·위험요인의 주기적인 점검 이행",
                is_checked: "",
              },
              {
                label: "점검 결과에 따른 중대시민재해 발생 우려시 신고 절차 마련 및 조치",
                is_checked: "",
              },
              {
                label: "중대시민재해 발생시 신고, 보고 및 조치 절차 마련",
                is_checked: "",
              },
              {
                label: "중대시민재해 원인조사에 따른 개선조치",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전보건 관계 법령(개별법령)에 따른 의무이행 점검 [중처법 시행령 제9조제2항제1호]",
            chlid: [
              {
                label: "의무이행사항 점검",
                is_checked: "",
              },
              {
                label: "미이행 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전보건 의무교육 시행 점검 [중처법 시행령 제9조제2항제2호]",
            chlid: [
              {
                label: "교육 이수 점검",
                is_checked: "",
              },
              {
                label: "미이수 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
        ],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: [],
      },
    };
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    targetCompany(value) {
      this.form.inputA_1 = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}
</style>
